import { render, staticRenderFns } from "./ClaimsProcess.vue?vue&type=template&id=579bb9df"
import script from "./ClaimsProcess.vue?vue&type=script&lang=js"
export * from "./ClaimsProcess.vue?vue&type=script&lang=js"
import style0 from "./ClaimsProcess.vue?vue&type=style&index=0&id=579bb9df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports